import graphql__3b4c23572687148fee78 from "./__generated__/ContactDataProtectionView_contact.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Panel from "./presentational/Panel";
import {useFragment} from "react-relay/hooks";
import ContactDataOriginList from "./ContactDataOriginList";
import {hideModal, showModal} from "../store/actions";
import {connect, ConnectedProps} from "react-redux";
import {useOutletContext} from "react-router";
import {useIntl} from "react-intl";

type Props = {}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type ContactDataProtectionViewProps = Props & ConnectedProps<typeof connector>;

const ContactDataProtectionView: React.FC<ContactDataProtectionViewProps> = (props) => {
    const intl = useIntl();
    const queryRef: any = useOutletContext();

    const contact = useFragment(
        graphql__3b4c23572687148fee78,
        queryRef
    );
    if (contact == null) {
        return <p>{intl.formatMessage({id: 'contact.notFound'})}</p>;
    }

    return (
        <>
            {contact.__typename === 'PersonContact' && (<Panel headline={intl.formatMessage({id: 'view.dataProtection.dataOrigins'})}>
                <ContactDataOriginList queryRef={contact}/>
            </Panel>)}
        </>
    );
}

export default connector(ContactDataProtectionView);
